






























import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import moment from "moment";
import { FormQuestion } from "@/store/modules/types";
import { BFormDatepicker } from "bootstrap-vue";
import DatePicker from "vuejs-datepicker";

@Component({
  components: {
    BFormDatepicker,
    DatePicker,
  },
})
export default class DateAnswer extends Vue {
  @Prop() readonly question!: FormQuestion;
  date: Date | null = null;
  format = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    weekday: "short",
  };
  @Watch("date")
  onDateChanged() {
    const date = this.$moment(this.date).format("YYYY-MM-DD");
    this.$emit("answer", this.question.id, date);
  }
  mounted() {
    const { answer } = this.question;
    if (answer.value) {
      const date = moment(answer.value);
      if (date.isValid()) this.date = date.toDate();
    }
  }
}
